'use client';

import { c as _c } from "react/compiler-runtime";
import { ExternalLink, Lock, ShieldCheck } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
type Props = {
  postId: string;
  // A post held on our servers and visible only to its owner — a synced vault
  // file, or one whose visibility was toggled. The default (false) is the
  // device-local kind, and the two must never share copy: telling someone a
  // server-stored file "never leaves your device" is simply untrue.
  serverStored?: boolean;
};
const PrivateBadge = t0 => {
  const $ = _c(11);
  const {
    postId,
    serverStored: t1
  } = t0;
  const serverStored = t1 === undefined ? false : t1;
  const [open, setOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.stopPropagation();
      setOpen(true);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Lock size={12} />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = serverStored ? "only you" : "private";
  let t5;
  if ($[2] !== t4) {
    t5 = <button type="button" onClick={t2} className="flex items-center gap-1 rounded-full bg-background-secondary/50 px-2 py-0.5 text-xs font-emphasis text-textSecondary/70 transition-colors hover:bg-background-secondary">{t3}{t4}</button>;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== open || $[5] !== postId || $[6] !== serverStored) {
    t6 = open && <Modal closeHandler={() => setOpen(false)}><ModalHeader closeHandler={() => setOpen(false)}><div className="flex items-center gap-2"><Lock className="text-primary" /><h2 className="text-xl font-semibold">{serverStored ? "Visible Only to You" : "Private Post"}</h2></div></ModalHeader><ModalContent><div className="space-y-4 py-2"><p className="text-textSecondary">This post is private and only visible to you.</p><div className="flex items-start gap-3"><ShieldCheck className="mt-1 shrink-0 text-primary" size={20} /><div>{serverStored ? <><h3 className="font-semibold">Stored on Our Servers</h3><p className="text-sm text-textSecondary">No other account can see this post. It is held on our servers rather than only on this device, so it is available wherever you sign in.</p></> : <><h3 className="font-semibold">Stored on Your Device</h3><p className="text-sm text-textSecondary">Private posts never leave your device. No one else can see them — not even us.</p></>}</div></div></div></ModalContent><ModalFooter><Link href={`/private-post/${postId}`} onClick={_temp}><Button text="View Post" icon={<ExternalLink size={16} />} /></Link></ModalFooter></Modal>;
    $[4] = open;
    $[5] = postId;
    $[6] = serverStored;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default PrivateBadge;
function _temp(e_0) {
  return e_0.stopPropagation();
}